import { SMSDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useSendSMS(onSuccess: () => void) {
  const url = '/v2/orm/sms/twilio';
  const request = new Request(url, {
    method: 'POST',
  });
  return useAuthenticatedMutation<null, SMSDTO>(request, {
    getBody: (data: SMSDTO): BodyInit => {
      const formData = new FormData();
      formData.append('to_number', data.to_number);
      formData.append('message', data.message);
      if (data.location_id !== undefined) {
        formData.append('location_id', String(data.location_id));
      }
      if (data.location_alarm_id !== undefined) {
        formData.append('location_alarm_id', String(data.location_alarm_id));
      }
      if (data.alarm_group_id !== undefined) {
        formData.append('alarm_group_id', data.alarm_group_id);
      }
      if (data.to_name !== undefined) {
        formData.append('to_name', data.to_name);
      }
      data.snapshots?.forEach((snapshot) =>
        formData.append('snapshots', snapshot)
      );
      return formData;
    },
    onSuccessInvalidationKeys: [['location_alarm_updates']],
    onSuccess,
  });
}
